import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", {
  class: "titleDD",
  style: {"padding-top":"24px"}
}, "Información financiera", -1)
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"flex-start","gap":"6px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", {
  class: "titleDD",
  style: {"margin":"0"}
}, "Documentos soporte", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" * Los archivos adjuntos, no pueden tener el mismo nombre.")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" * En caso de adicionar más de un documento, da clic sobre el botón '+'")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" * Si necesitas eliminar uno de los documentos, da clic en 'x'")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" * Los tipos de archivos permitidos para cargar documentos son .pdf, .jpg y .png")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" * El tamaño máximo de todos los archivos cargados debe ser de 20 MB.")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Adjuntar +")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "auto",
    class: "greenItem"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Total ingresos operacionales" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: { locale: 'pt-BR', currency: 'COP', currencyDisplay: 'narrowSymbol' },
                    modelValue: _ctx.objetoFinanciera.IngresosOperacionales,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objetoFinanciera.IngresosOperacionales) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validarIngresos()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionFinanciera.IngresosOperacionales.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Total ingresos no operacionales" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: { locale: 'pt-BR', currency: 'COP', currencyDisplay: 'narrowSymbol' },
                    modelValue: _ctx.objetoFinanciera.IngresosNoOperacionales,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objetoFinanciera.IngresosNoOperacionales) = $event)),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validarIngresos()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionFinanciera.IngresosNoOperacionales.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.justificarIngresos)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 24,
            justify: "space-evenly",
            style: {"margin-top":"24px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                md: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "Indica el motivo por el cual los ingresos no operacionales son mayores a los operacionales." })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                md: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 4,
                        placeholder: "Máximo 250 caracteres.",
                        modelValue: _ctx.objetoFinanciera.JustificacionIngresos,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objetoFinanciera.JustificacionIngresos) = $event)),
                        maxlength: "250",
                        "show-word-limit": "",
                        class: "fixed-textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionFinanciera.JustificacionIngresos.$errors, (error) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: error.$uid
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(error.$message), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                id: "bold-file",
                label: " "
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24,
            style: {"padding-top":"15px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_el_tooltip, {
                  placement: "bottom",
                  "open-delay": "0",
                  effect: "customized",
                  class: "tooltip-adjuntos"
                }, {
                  content: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'info-circle'],
                      color: "#00805d",
                      style: {"font-size":"13px","margin-top":"4px"}
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, { label: "Estados financieros." })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionFinanciera.Documentos.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { xs: 24 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionFinanciera.NombresArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionFinanciera.TamañoArchivo.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.eliminarEstadoFinanciero,
                "on-change": _ctx.cargarEstadoFinanciero,
                "file-list": _ctx.estadosFinancieros,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoFinanciera.Documentos.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objetoFinanciera.Documentos.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoFinanciera.TamañoArchivo,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objetoFinanciera.TamañoArchivo) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoFinanciera.NombresArchivos,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objetoFinanciera.NombresArchivos) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change", "file-list"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}